import { render, staticRenderFns } from "./DayaDukungView.vue?vue&type=template&id=5e53f288&scoped=true"
import script from "./DayaDukungView.vue?vue&type=script&lang=js"
export * from "./DayaDukungView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53f288",
  null
  
)

export default component.exports